export default "__VITE_ASSET__m5h1OZ1N__"